import { useEffect, useState } from "react";

import { isCheckdAll, objectGenerator } from "../../../lib";
import IconButton from "../../../../../components/IconButton";
import { IconEye } from "../../../../../icons";
import useRoutineAppointment from "../../../store/useRoutineAppointment";
import { generatorId } from "../../../../../libs/key-generator";
import { ModalDetailsTimesheet } from "../../../../../components/ModalDetailsTimesheet";

const uuid = generatorId();

function TbodyComponent({ details, dateFrom, dateTo, checkboxSelection, checkedAll }: any) {
  const { setInitialValue, orderByField, stateSwitch, listRender, page, selectSize } = useRoutineAppointment();

  const [listCheckbox, setListCheckbox] = useState(listRender);
  const [needSpinner, setNeedSpinner] = useState(true);
  const [needSpinnerModal, setNeedSpinnerModal] = useState(false);
  const [modalValue, setModalValue] = useState({
    userId: 0,
    userName: "",
  });

  useEffect(() => {
    setNeedSpinner(false);
  }, [listCheckbox]);

  useEffect(() => {
    if (checkedAll) {
      const newcheckList = listCheckbox?.map((item: any) => {
        return isCheckdAll(item, true);
      });
      setListCheckbox(newcheckList);
      setInitialValue(newcheckList);
    } else {
      const newcheckList = listCheckbox?.map((item: any) => {
        return isCheckdAll(item, false);
      });
      setListCheckbox(newcheckList);
      setInitialValue(newcheckList);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkedAll]);

  function handleCheckboxChange(event: React.ChangeEvent<HTMLInputElement>) {
    const valueId = event.target.value;
    checkedListCheckbox(Number(valueId));
  }

  function checkedListCheckbox(id: number) {
    const newcheckList = listCheckbox?.map((item: any) => {
      const label = item.userId || item.id;
      if (Number(label) !== Number(id)) return item;
      const data = {
        ...objectGenerator(item),
      };
      return data;
    });
    setInitialValue(newcheckList);
    setListCheckbox(newcheckList);
  }

  function handleModalValue(row: any) {
    setNeedSpinnerModal(false);
    const data = {
      userId: row.userId,
      userName: row.userName,
    };
    setModalValue(data);
    setNeedSpinnerModal(true);
  }

  function exitModal() {
    setNeedSpinnerModal(false);
  }

  function thisRender(index: number) {
    const initialListRender = index < (page + 1) * Number(selectSize);
    const endListRender = index >= page * Number(selectSize);
    return initialListRender && endListRender;
  }

  return (
    <>
      {listCheckbox?.length ? (
        <tbody>
          {needSpinnerModal && <div className="overlay" onClick={() => exitModal()}></div>}
          {needSpinnerModal && <ModalDetailsTimesheet exit={exitModal} dateFrom={dateFrom} dateTo={dateTo} value={modalValue} />}
          {!needSpinner &&
            listCheckbox?.map((row: any, index: number) => {
              if (row?.consolidatedHours !== stateSwitch) return;
              return (
                thisRender(index) && (
                  <tr key={uuid.generator()} className="tableRow">
                    {checkboxSelection && (
                      <td key={uuid.generator()} className="checkboxRow">
                        <input
                          className="checkboxInput"
                          checked={row.checked}
                          value={row.userId || row.id}
                          onChange={(event) => handleCheckboxChange(event)}
                          type="checkbox"
                        />
                      </td>
                    )}
                    {orderByField?.map((i: string) => {
                      return (
                        <td className={`${row[i] === row.projectName && "invisible-850px"}`} key={uuid.generator()}>
                          {row[i]}
                        </td>
                      );
                    })}
                    {details && (
                      <td key={uuid.generator()}>
                        <IconButton className="iconEye" icon={IconEye} onClick={() => handleModalValue(row)} />
                      </td>
                    )}
                  </tr>
                )
              );
            })}
        </tbody>
      ) : (
        <div className="nothing-list">
          <h1>Não há registros para a busca realizada.</h1>
        </div>
      )}
    </>
  );
}

export default TbodyComponent;
